import * as z from "zod";

export enum InstallSource {
  MAIN_APP = "main",
  /**
   * Originally the "Order Tracking" Shopify app; now repurposed as the "Recover" app.
   * The string value is kept as "order_tracking" for backward compatibility.
   * Enum name still contains the string ORDER_TRACKING_APP so that it shows up when grepping
   * for related environment variables.
   */
  ORDER_TRACKING_APP_BUT_ACTUALLY_RECOVER = "order_tracking",
  RECLAIM_APP = "reclaim",
}

export const installSourceSchema = z.enum(InstallSource);
